import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import MembresiaTrackingClub from "../../../../types/MembresiaTrackingClub";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { formConfigBuilder, Inputs, Buttons } from "./TrackingClubesRow.form";

interface Props {
  periodo: string;
  data: MembresiaTrackingClub[];
  onUpdate: (
    index: number,
    data: MembresiaTrackingClub,
    hasError: boolean
  ) => void;
  saveKey: number;
}

export default function TrackingClubesTable({
  periodo,
  data,
  onUpdate,
  saveKey
}: Props) {
  const [periodoAnterior, setPeriodoAnterior] = useState(false);

  useEffect(() => {
    // Periodo sin cambio de día
    const fechaPeriodo = new Date(`${periodo}T00:00:00Z`);
    const mesPeriodo = fechaPeriodo.getUTCMonth();
    const anioPeriodo = fechaPeriodo.getUTCFullYear();

    // Fecha actual
    const fechaActual = new Date();
    const mesActual = fechaActual.getMonth();
    const anioActual = fechaActual.getFullYear();

    // Periodo anterior
    setPeriodoAnterior(
      anioPeriodo < anioActual ||
        (anioPeriodo === anioActual && mesPeriodo < mesActual)
    );
  }, [periodo]);

  const handleFormChange = (index: number) => (values, hasError) => {
    const updatedItem = {
      ...data[index],
      ...values
    };
    onUpdate(index, updatedItem, hasError);
  };

  return (
    <div>
      <Table striped bordered hover>
        <thead
          className="sticky-top"
          style={{
            background: "#f9f9f9",
            position: "sticky",
            top: "110px",
            zIndex: 1
          }}
        >
          <tr>
            <th style={{ width: "8%", maxWidth: "8%" }}>Clave</th>
            <th style={{ width: "20%", maxWidth: "20%" }}>Club</th>
            <th style={{ width: "16%", maxWidth: "16%" }}>
              Número de Asesores
            </th>
            <th style={{ width: "16%", maxWidth: "16%" }}>Meta Consolidada</th>
            <th style={{ width: "16%", maxWidth: "16%" }}>
              Número de Prospectos
            </th>
            <th style={{ width: "24%", maxWidth: "24%" }}>Ingreso</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={`${saveKey}-${item.periodo}-${item.idClub}-${index}`}>
              <td style={{ verticalAlign: "middle" }}>{item.clubClaveCorta}</td>
              <td style={{ verticalAlign: "middle" }}>{item.clubNombre}</td>
              <FormBuilder<Inputs, Buttons>
                config={formConfigBuilder(periodoAnterior)}
                init={{
                  numeroAsesores: item.numeroAsesores,
                  consolidadoPresupuesto: item.consolidadoPresupuesto,
                  numeroProspectosPresupuesto: item.numeroProspectosPresupuesto,
                  totalVentasPresupuesto: item.totalVentasPresupuesto
                }}
                onChange={handleFormChange(index)}
                asTable={true}
                expandRowOnClick={true}
              />
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
